import { useMemo } from 'react';

import { css, styled } from '@mui/material';
import { Grid } from '@kc-console/common-ui';
import { useScrollObserverRootHeight } from '@kc-console/context';

import type { FormContainerProps } from './types';

const FormContainer = ({ children, ...props }: FormContainerProps) => {
  const rootHeight = useScrollObserverRootHeight();
  const rootHeightWithOffset = useMemo(() => (rootHeight ? rootHeight - 32 : 0), [rootHeight]);

  return (
    <FormContainerRoot lastSectionMinHeight={rootHeightWithOffset} {...props}>
      {children}
    </FormContainerRoot>
  );
};

export default FormContainer;

const FormContainerRoot = styled(Grid, {
  shouldForwardProp: prop => prop !== 'lastSectionMinHeight',
})<{ lastSectionMinHeight?: number } & FormContainerProps>(
  ({ lastSectionMinHeight = 0 }) => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    & > *:last-child {
      min-height: ${lastSectionMinHeight}px;
    }
  `,
);
